export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const FETCH_EMPLOYEES = "FETCH_EMPLOYEES";
export const FETCH_EMPLOYEE = "FETCH_EMPLOYEE";
export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const EMPLOYEE_BASIC_DDL = "EMPLOYEE_BASIC_DDL";
